import * as React from 'react'
import styled, { ThemeProps } from 'style/styled-components'
import Theme from 'style/theme'

const StyledPageTitle = styled.h1`
  font-size: 2.5em;
  font-weight: ${(props: ThemeProps<Theme>): string => props.theme.font.weight.normal};
`

const PageTitle = (props: React.HTMLAttributes<HTMLHeadingElement>): JSX.Element => (
  <StyledPageTitle {...props} />
)

export default PageTitle



// WEBPACK FOOTER //
// ./src/components/_atoms/pageTitle.tsx